export default { toggleTrips };

function toggleTrips () {
  const { selectedTrip, trips } = this.state;
  for (let i = 0; i < trips.length; i++) {
    let trip = trips[ i ];
    if (selectedTrip.id === trip.id) {
      if (i === trips.length - 1) {
        this.setState({ selectedTrip: trips[ 0 ] });
        return;
      }
      let nextTrip = trips[ i + 1 ];
      if (nextTrip) {
        this.setState({ selectedTrip: nextTrip });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/flights/tripsSwitch/TripsSwitchController.js